import React, {useContext} from 'react';
import {Controller} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {FormFieldConfigSize} from '@src/@types/components/Form';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import CustomSelect from '@src/components/Fields/CustomSelect';
import classnames from '@src/helpers/classnames';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import {IClientModel} from '@src/@interfaces/models/Client/IClientModel';

const emptyArray: never[] = [];

export function TypeField({rowIndex: index}: IListColumnProps) {
    const {
        control,
        fieldName,
        modelOptions = {},
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IClientModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);

    return <>
        <Controller
                control={control}
                name={`${fieldName}.${index}.type`}
                render={({field: {name, value, onChange, onBlur}, fieldState: {error}}) => {
                    return <CustomSelect
                            label="ContractorsShow.fields.contacts.type"
                            className={classnames({
                                'is-invalid': Boolean(error)
                            })}
                            name={name}
                            size={FormFieldConfigSize.SM}
                            options={modelOptions.contactTypes ?? emptyArray}
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={design.fieldsAreDisabled || forceDisabled}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            menuPortalTarget={document.body}
                    />;
                }}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.type`}/>
    </>;
}
